const sbs = () => {
  const items = document.querySelectorAll('.p-sbs__item');

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const item = entry.target;
                if (item.classList.contains('is-last')) {
                    // is-lastクラスのある要素はただちに表示
                    item.style.transform = 'translate(0px, 0px)';
                    item.style.opacity = '1';
                } else {
                    // 他の要素には遅延を追加
                    const delay = Array.from(items).indexOf(item) * 100; // 各要素に100msずつ遅延を追加
                    setTimeout(() => {
                        item.style.transform = 'translate(0px, 0px)';
                        item.style.opacity = '1';
                    }, delay);
                }
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });

    items.forEach(item => {
        item.style.transform = 'translate(0px, 10px)';
        item.style.opacity = '0';
        observer.observe(item);
    });
};
